import React, { Fragment } from "react";
import { NavLink, useParams } from "react-router-dom";
import { gql, useQuery } from "@apollo/client";
import { Card, Layout, Row, Menu, Button, Typography, Checkbox } from "antd";

import { CenterSpinner } from "components/CenterSpinner";
import { CenterResult } from "components/CenterResult";

const accountRoleQuery = gql`
  query($id: ID!) {
    accountRole(id: $id) {
      id
      name
      authorization {
        canManageAccounts
      }
    }
  }
`;

export const Show: React.FC<{}> = () => {
  const { id } = useParams();

  const { error, loading: queryLoading, data } = useQuery(accountRoleQuery, {
    variables: { id },
    fetchPolicy: "cache-and-network",
  });

  if (queryLoading) return <CenterSpinner size="large" />;
  if (error)
    return (
      <CenterResult
        status="404"
        title="404"
        subTitle="Sorry, the page you visited does not exist."
        extra={
          <NavLink to="../">
            <Button type="primary">Back to list</Button>
          </NavLink>
        }
      />
    );

  return (
    <Fragment>
      <Layout.Header className="header-background">
        <Row justify="space-between">
          <Menu theme="light" mode="horizontal">
            <Menu.Item className="no-border">
              <Typography.Title level={4} style={{ lineHeight: "auto" }}>
                Show
              </Typography.Title>
            </Menu.Item>
          </Menu>
          <Menu theme="light" mode="horizontal">
            <Menu.Item className="no-border no-margin">
              <NavLink to="../">
                <Button>Back</Button>
              </NavLink>
            </Menu.Item>
            <Menu.Item className="no-border">
              <NavLink to="./edit">
                <Button type="primary">Edit</Button>
              </NavLink>
            </Menu.Item>
          </Menu>
        </Row>
      </Layout.Header>
      <Layout className="content">
        <Layout.Content className="content">
          <Card>
            <Typography.Title level={2}>{data?.accountRole.name}</Typography.Title>
            <Typography.Title level={4}>Global Authorization</Typography.Title>
            <Checkbox disabled checked={data?.accountRole.authorization.canManageAccounts}>
              Can manage accounts
            </Checkbox>
          </Card>
        </Layout.Content>
      </Layout>
    </Fragment>
  );
};
